import React from 'react';
import { Card } from 'react-bootstrap';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor, rgbaColor } from 'helpers/utils';
import { useEffect, useState } from 'react';
import SettingsService from 'components/app/directory/SettingsService';
echarts.use([LineChart, TooltipComponent, GridComponent, CanvasRenderer]);

const formatCurrency = (value, currency) => 

  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency
  }).format(value);

const getOption = trend => ({
  grid: { top: 10, right: 0, bottom: 0, left: 0 },
  xAxis: {
    type: 'category',
    show: false,
    boundaryGap: false,
    data: trend.map((_, index) => index)
  },
  yAxis: {
    type: 'value',
    show: false
  },
  series: [
    {
      type: 'line',
      data: trend,
      symbol: 'none',
      smooth: false,
      lineStyle: {
        color: getColor('primary'),
        width: 2
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: rgbaColor(getColor('primary'), 0.3) },
            { offset: 1, color: rgbaColor(getColor('primary'), 0) }
          ]
        }
      }
    }
  ],
  tooltip: { show: false }
});

const MonthlyRevenueCard = ({ data }) => {
  const [currency, setCurrency] = useState('GBP');
  useEffect(() => {
    console.log('MonthlyRevenueCard data:', data);
    SettingsService.retrieveDefaultCurrency()
      .then(currency => {
        console.log('Default currency:', currency);
        setCurrency(currency.toUpperCase());

      })
      .catch(error => console.log('Error fetching default currency:', error));
  }, [data]);
  return (
    <Card className="h-100 border-0 shadow-sm">
      <Card.Body>
        <p className="text-body-tertiary mb-2">Monthly revenue</p>
        <div className="d-flex align-items-start justify-content-between">
          <div>
            <h2 className="fw-bold mb-1">{formatCurrency(data.current, currency)}</h2>
            <span className="text-success fw-semibold">
              {data.isPositive ? '+' : '-'}
              {formatCurrency(data.change, currency)}
            </span>
          </div>
          <div style={{ width: '45%', height: '60px' }}>
            <ReactEChartsCore
              echarts={echarts}
              option={getOption(data.trend)}
              style={{ height: '100%', width: '100%' }}
            />
          </div>
        </div>
        <hr className="my-3" />
        <p className="text-body-tertiary mb-0">
          Predicted <strong className="text-body-emphasis">{formatCurrency(data.predicted, currency)}</strong>
        </p>
      </Card.Body>
    </Card>
  );
};

export default MonthlyRevenueCard;
